import { PatientMessagesPage } from "./patientMessages";

export const PatientMessages = PatientMessagesPage;
